import {Alert} from '../../types/interfaces/alert';

export class FetchAlerts {
  static readonly type = '[Alerts] Fetch All';

  constructor(public payload: Alert[]) {
  }
}
